import { EntityID, World } from "@latticexyz/recs";
import { BigNumber } from "ethers";

export { worldCoordToPixel } from "./worldCoordToPixel";
export { pixelToWorldCoord } from "./pixelToWorldCoord";

export function ethersBnToEntityIndex(world: World, bn: BigNumber) {
  return world.getEntityIndexStrict(bn._hex as EntityID);
}
